// extracted by mini-css-extract-plugin
export default {"desktop":"desktop","header":"M0WHhBHd"};